import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class MQTTConnectedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On MQTT Connected';
        this.id = 'node_mqtt_connected';
        this.linkedFeature = 'mqtt_lib';
        this.icon = 'VscDebugDisconnect';
        this.requirements = ['network'];

        this.outputs = [
            {
                name: 'MQTT Connected',
                portId: 'mqtt_connected',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'mqtt_connected');
        const codeLocationStart = PlatformUtils.getRuntimeCodeLocationStart(project.runtime);
        const codeLocationEnd = PlatformUtils.getRuntimeCodeLocationEnd(project.runtime);
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: 'callback_mqtt_connect_ok',
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `${codeLocationStart}${link.getSourceId()}${codeLocationEnd}`,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/mqtt_library';
    }
}
